import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

import { ref } from "vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'AccountStatusBadge',
  props: {
  status: { type: Number, required: true },
  showDot: { type: Boolean, default: false },
},
  setup(__props) {

const props = __props;


const badgeClass = ref({
  0: "badge-light-success",
  1: "badge-light-warning",
  2: "badge-light-danger",
});

const dotClass = ref({
  0: "text-success",
  1: "text-warning",
  2: "text-danger",
});

return (_ctx: any,_cache: any) => {
  return (!__props.showDot)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["badge", badgeClass.value[__props.status]])
      }, _toDisplayString({
        0: _ctx.$t("status.normal"),
        1: _ctx.$t("status.paused"),
        2: _ctx.$t("status.closed"),
      }[props.status]), 3))
    : (_openBlock(), _createElementBlock("i", {
        key: 1,
        class: _normalizeClass(["fa-solid fa-circle-dot", dotClass.value[__props.status]])
      }, null, 2))
}
}

})